import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { MaskedLines, Eyebrow } from "../site/Reveal";
import { CONTACT } from "../../data/services";

export const ClosingCta = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);
  return (
    <section ref={ref} className="relative overflow-hidden bg-[#0A192F] py-28 sm:py-40" data-testid="home-cta">
      <motion.img style={{ y }} src="/images/office.jpg" alt="" className="absolute inset-0 h-[124%] w-full object-cover opacity-25" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#070F1E] via-[#070F1E]/85 to-[#070F1E]/40" />
      <div className="relative mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12">
        <Eyebrow dark>Begin here</Eyebrow>
        <h2 className="mt-6 font-display text-[#F4EEE3] text-5xl sm:text-7xl lg:text-8xl leading-[0.92] tracking-tight">
          <MaskedLines inView delay={0} lines={["Every safe deal", <span className="italic text-[#E3C88A]">starts with a call.</span>]} />
        </h2>
        <div className="mt-12 flex flex-wrap gap-4">
          <a href={`tel:${CONTACT.tel}`} data-testid="cta-call-btn" className="inline-flex items-center gap-3 rounded-full bg-[#C5A059] px-8 py-4 text-[#070F1E] font-medium transition-[background-color] duration-300 hover:bg-[#E3C88A]">Call {CONTACT.phone}</a>
          <Link to="/contact" data-testid="cta-enquire-btn" className="inline-flex items-center gap-3 rounded-full border border-[#C5A059]/60 px-8 py-4 text-[#F4EEE3] transition-[background-color] duration-300 hover:bg-white/5">Send an enquiry <ArrowUpRight className="h-4 w-4" /></Link>
        </div>
      </div>
    </section>
  );
};
